var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58944 0 0 3.58944 0 8C0 12.4106 3.58944 16 8 16C12.4106 16 16 12.4106 16 8C16 3.58944 12.4106 0 8 0ZM8 14.8739C4.22287 14.8739 1.1261 11.8006 1.1261 8C1.1261 4.19941 4.19941 1.1261 8 1.1261C11.8006 1.1261 14.8739 4.19941 14.8739 8C14.8739 11.8006 11.7771 14.8739 8 14.8739Z",
    fill: "#FE1717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6835 7.36719H4.31696C4.01197 7.36719 3.75391 7.62525 3.75391 7.93024C3.75391 8.23522 4.01197 8.49329 4.31696 8.49329H11.6835C11.9885 8.49329 12.2466 8.23522 12.2466 7.93024C12.2466 7.62525 11.9885 7.36719 11.6835 7.36719Z",
    fill: "#FE1717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveLogo);
export default __webpack_public_path__ + "static/media/remove-logo.e46543dd250da6607379f722e3039ab4.svg";
export { ForwardRef as ReactComponent };